import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function ShortRedirect() {
  const { code } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/links/resolve/${code}`)
      .then((r) => { window.location.href = r.data.target_url; })
      .catch(() => nav("/", { replace: true }));
  }, [code, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center text-slate-400">
        <div className="h-10 w-10 rounded-full border-2 border-blue-600 border-t-transparent animate-spin mx-auto mb-4" />
        Yönlendiriliyor...
      </div>
    </div>
  );
}
